import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
const solutions = ['Acceso inmediato al sistema completo', 'Método paso a paso probado y validado', 'Soporte prioritario 24/7 en español', 'Actualizaciones gratuitas de por vida', 'Comunidad privada exclusiva'];
export function SolutionSection() {
  return <section className="bg-gradient-to-b from-white to-pink-50 py-12 md:py-16 px-4" data-id="element-226">
      <div className="container mx-auto max-w-4xl" data-id="element-227">
        <h2 className="text-3xl md:text-5xl font-extrabold text-pink-600 text-center mb-4 md:mb-6 leading-tight" data-id="element-228">
          Esto Es Lo Que Obtienes
        </h2>
        <p className="text-lg md:text-2xl text-rose-500 text-center mb-8 md:mb-12 font-bold" data-id="element-229">
          TODO lo que necesitas para empezar HOY
        </p>

        <div className="space-y-4 md:space-y-6" data-id="element-230">
          {solutions.map((solution, index) => <div key={index} className="bg-white border-2 border-pink-300 rounded-lg p-5 md:p-6 shadow-lg" data-id="element-231">
              <div className="flex items-center gap-4" data-id="element-232">
                <div className="bg-pink-500 rounded-full p-2 flex-shrink-0" data-id="element-233">
                  <CheckCircleIcon className="w-6 h-6 md:w-8 md:h-8 text-white" aria-hidden="true" data-id="element-234" />
                </div>
                <p className="text-lg md:text-2xl text-stone-800 font-bold leading-tight" data-id="element-235">
                  {solution}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}